import { useMutation } from "@tanstack/react-query";
import type { BuildingDto } from "@klantpunt/shared";
import { api, ApiError } from "../../lib/api";
import { useToast } from "../../lib/toast";

/**
 * Melden zonder inloggen (Gebouw › Gegevens, docs/MELDINGEN.md §2): per gebouw aan of uit, standaard uit.
 * Alleen eigenaar en beheerder wijzigen het. Later komen hier de gebouwlink en de meldpagina bij.
 */
export function IntakeSettings({
  building: b,
  canManage,
  onSaved,
}: {
  building: BuildingDto;
  canManage: boolean;
  onSaved: (b: BuildingDto) => void;
}) {
  const toast = useToast();
  const save = useMutation({
    mutationFn: (assetQr: boolean) =>
      api<{ assetQr: boolean }>(`/buildings/${b.id}/intake`, { method: "PUT", body: { assetQr } }),
    onSuccess: (r) => {
      onSaved({ ...b, intakeAssetQr: r.assetQr });
      toast(r.assetQr ? "Melden via de QR-code staat aan" : "Melden via de QR-code staat uit");
    },
    onError: (e) => toast(e instanceof ApiError ? e.message : "Opslaan mislukt"),
  });
  return (
    <fieldset className="q intake-settings" aria-busy={save.isPending}>
      <legend className="ql">Melden zonder inloggen</legend>
      <label className="checkrow">
        <input
          type="checkbox"
          checked={b.intakeAssetQr}
          disabled={!canManage || save.isPending}
          onChange={(e) => save.mutate(e.target.checked)}
        />
        <span>
          Via de QR-code bij een asset
          <span className="muted small block">
            {b.intakeAssetQr
              ? "Na het scannen ziet iedereen de keuringen en de knop Probleem melden. Meldingen komen in de Inbox › Te beoordelen."
              : "Na het scannen ziet iemand zonder inloggen alleen de asset en de keuringen."}
          </span>
        </span>
      </label>
    </fieldset>
  );
}
